/**
 * Scroll to bottom of element
 * @param {string} selector - class/id of the HTML element
 */
export function scrollToBottom(selector: string) {
  const container = document.querySelector(selector)
  container && (container.scrollTop = container.scrollHeight)
}

/**
 * Trim white spaces before and after string, as well as extra white spaces in between words
 * @param {string} stringToTrim - string to be trimmed
 */
export function trimExtraWhiteSpaces(stringToTrim: string) {
  return (stringToTrim?.trim())?.replace(/  +/g, ' ')
}

// Used to sort string a and string b from an array alphabetically, case-insensitive
 export function compare(a: string, b: string) {
  if (a.toLowerCase() < b.toLowerCase()) return -1
  else if (a.toLowerCase() > b.toLowerCase()) return 1
  else return 0
}

// Validate email using regex from validating email on join form
export function validateEmailUtil(email: string) {
  const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return regex.test(email)
}

// Check if phone string contains only 10 digits. 1st and 4th digits can't be 0/1 (special requirement)
export function validatePhoneUtil(phone: string) {
  const regex = /^\d{10}$/,
        checkFirstFourthDigits = phone[0] !== "1" && phone[3] !== "1" && phone[0] !== "0" && phone[3] !== "0"
  return regex.test(phone) && checkFirstFourthDigits
}

// Remove "Z" part from the date string so the date time remains to be the same in  all time zones
export function removeTimeZoneAndGetDate(date: string) {
  return date ? new Date(date.split("Z")[0]) : null
}

// Util to calculate the total number of pages with total number of element on each page and total number of elements
export function calculateTotalPagesUtil(totalElements: number, elementsPerPage: number) {
  return Math.ceil(totalElements / elementsPerPage)
}